import { gql } from '@apollo/client';

export const LeadListQuery = gql`
  query LeadList($leadListId: ID!) {
    leadList(leadListId: $leadListId) {
      createdAt
      errors {
        code
        description
      }
      originalFilename
      flaggedLeadsCount
      id
      leadCount
      rejectedLeadsCount
      removedUnpostedLeadCount
      sentToCampaignTimestamp
      status
    }
  }
`;
